import * as React from 'react'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import { useState, useEffect } from 'react'
import { Icon, IconButton, Tooltip } from '@mui/material'

interface FormDialogProps {
  title: string
  contentText: string
  nameLabelField: string
  onButtonClick: () => void
  onCheckboxChange: (isChecked: boolean, queryName: string) => void
  isShowCheckBox?: boolean
  nameTypeField?: string
  nameHelperText?: string
  nameButtonCancel?: string
  nameButtonConfirm?: string
  iconButtonProps?: any
  tooltip: string
}

const FormDialog: React.FC<FormDialogProps> = (props: FormDialogProps): JSX.Element => {
  const [open, setOpen] = useState(false)
  const [isChecked, setIsChecked] = useState(false)
  const [queryName, setQueryName] = useState('')

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setQueryName(event.target.value)
  }

  useEffect(() => {
    props.onCheckboxChange(isChecked, queryName)
  }, [queryName])

  const handleClickOpen = (): void => {
    setOpen(true)
  }

  const handleClose = (): void => {
    setOpen(false)
    setIsChecked(false)
    setIsChecked(false)
    setQueryName('')
  }

  const handleButtonClick = (): void => {
    props.onButtonClick()
    handleClose()
  }

  const handleOnChangeCheckBox = (): void => {
    const checked = !isChecked
    setIsChecked(checked)
    props.onCheckboxChange(checked, queryName)
  }

  return (
    <div>
      <Tooltip title={props.tooltip}>
      <span>
      <IconButton
          onClick={handleClickOpen}
          {...(props.iconButtonProps ?? {})} // Spread the iconButtonProps object
      >
        {props.iconButtonProps?.children ?? <Icon>save</Icon>}
      </IconButton>
      </span>
      </Tooltip>
      <Dialog fullWidth open={open} onClose={handleClose}>
        <DialogTitle>{props.title}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {props.contentText}
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label={props.nameLabelField}
            type={props.nameTypeField}
            helperText={props.nameHelperText}
            fullWidth
            variant="standard"
            size='medium'
            value={queryName}
            onChange={handleInputChange}
          />
          {(props.isShowCheckBox ?? false) && (
            <FormControlLabel required control={<Checkbox />} label="Is the query private?" onChange={handleOnChangeCheckBox}/>)}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>{props.nameButtonCancel}</Button>
          <Button onClick={handleButtonClick}>{props.nameButtonConfirm}</Button>
        </DialogActions>
      </Dialog>
    </div>
  )
}

FormDialog.defaultProps = {
  nameButtonCancel: 'Cancel',
  nameButtonConfirm: 'Confirm',
  nameHelperText: '',
  nameTypeField: 'text',
  isShowCheckBox: false
}

export default FormDialog
